var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.headerActionConfig, page: _vm.pageOptions }
      }),
      _c("div", { staticClass: "row bg-secondary-1 p-3 rounded" }, [
        _c(
          "div",
          { staticClass: "col-md-3 d-flex" },
          [
            _c("custom-drop-down", {
              staticClass: "flex-grow-1",
              attrs: {
                id: "ddlAcademicYear",
                clearable: false,
                fieldkey: "id",
                fieldname: "name",
                options: _vm.catalog.academicYears,
                placeholder: "Seleccione Año Fiscal"
              },
              model: {
                value: _vm.filter.academicYearId,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "academicYearId", $$v)
                },
                expression: "filter.academicYearId"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 d-flex" },
          [
            _c("custom-drop-down", {
              staticClass: "flex-grow-1",
              attrs: {
                id: "ddlHiringTypes",
                fieldkey: "id",
                fieldname: "name",
                options: _vm.hiringTypes,
                placeholder: "Seleccione Tipo de Contratación"
              },
              model: {
                value: _vm.filter.hiringType,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "hiringType", $$v)
                },
                expression: "filter.hiringType"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 d-flex" },
          [
            _c("custom-drop-down", {
              staticClass: "flex-grow-1",
              attrs: {
                id: "ddlFigureTypes",
                fieldkey: "id",
                fieldname: "name",
                options: _vm.catalog.figureTypes,
                placeholder: "Seleccione Tipo de Cifra"
              },
              model: {
                value: _vm.filter.figureType,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "figureType", $$v)
                },
                expression: "filter.figureType"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 d-flex" },
          [
            _c("action-button", {
              attrs: { i: "fas fa-search", text: "Buscar", variant: "success" },
              on: { click: _vm.onSearchHandler }
            })
          ],
          1
        )
      ]),
      _c("custom-separator", {
        staticClass: "pt-3 mb-4",
        attrs: { text: "Resultado de Cifras en Sistema" }
      }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm._l(_vm.accountNumbers.data, function(item, index) {
              return _c(
                "div",
                { key: "account-number" + index },
                [
                  _c("custom-callout", { staticClass: "mb-3 custom-callout" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v("Número de Cifra:")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "font-weight-bold color-black font-16"
                          },
                          [_vm._v(" " + _vm._s(item.fullNumber) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v("Grupo de Edad:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-normal color-black font-16"
                              },
                              [_vm._v(" " + _vm._s(item.serviceName) + " ")]
                            )
                          ]),
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Tipo de Contratación: ")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-normal color-black font-16"
                              },
                              [_vm._v(" " + _vm._s(item.hiringTypeName) + " ")]
                            )
                          ]),
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v("Tipo de Cifra:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-normal color-black font-16"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.figureTypeDescription) + " "
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v("Vigencia:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-bold color-black font-16"
                              },
                              [_vm._v(" " + _vm._s(item.effectiveDate) + " ")]
                            )
                          ])
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-md-2 text-right" },
                        [
                          _c("action-button", {
                            staticClass: "ml-4 px-4 transparent-color",
                            attrs: {
                              i: "fas fa-file-search",
                              text: "Ver Detalles",
                              variant: "outline-success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onEditHandler(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "d-flex mt-2" }, [
                      item.caats.length > 0 && _vm.isEquipoAsistivo(item)
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "color-secondary-6 font-14" },
                                [_vm._v(" Centro de Servicio: ")]
                              ),
                              _vm._l(item.caats, function(caat, index2) {
                                return _c(
                                  "div",
                                  {
                                    key: `caat-row-${index2}`,
                                    staticClass:
                                      "font-weight-bold color-black font-16"
                                  },
                                  [_vm._v(" " + _vm._s(caat.name) + " ")]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ])
                ],
                1
              )
            }),
            _vm.showPagination
              ? _c("pagination", {
                  attrs: {
                    data: _vm.accountNumbers.pagination,
                    "show-text": true
                  },
                  on: { "pagination-go-page": _vm.goToPage }
                })
              : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }